import React, { useMemo } from 'react';
import Chart from './chart';

import moment from 'moment';
import PercentageItem from '@/pages/opinion/components/Snippets/PercentageItem';
import RingRatioBubble from '@/pages/opinion/components/Snippets/RingRatioBubble';
import {
  sortTimeListFunc,
  getTimeSpaceArray,
  arrayToObj,
  initialUpperCase,
} from '@/pages/opinion/utils';
import { formatNewData } from '@/pages/opinion/utils/data';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import './index.scss';
import { useIntl } from 'umi';
import BubbleCommon from '@op/components/BubbleCommon';

export default function CardTrends({
  itemInfo,
  channel = {},
  keepParams,
}: any) {
  const [statistics, totalInfo, noData] = useMemo(() => {
    let localStatistics = {};
    let localTotalInfo = {
      total: 0,
      total_old: 0,
      total_ratio: 0,
      oldTime: [],
      newTime: [],
    };
    let localNoData = true;
    if (itemInfo.flag) {
      let {
        timeline,
        total,
        total_old,
        total_ratio,
        oldTime,
        newTime,
        timeline_of_end_time,
        timeline_of_start_time,
      } = itemInfo;
      const newList = formatNewData(timeline || []);
      newList.sort((a, b) => sortTimeListFunc('time')(a, b));
      const timeList = getTimeSpaceArray(
        timeline_of_start_time,
        timeline_of_end_time,
      );
      const x: Array<any> = timeList;
      const y: Array<any> = [];
      const newListObj = arrayToObj(newList, ({ time }) =>
        moment(time).format('YYYY-MM-DD'),
      );

      timeList.forEach((time) => {
        y.push(
          newListObj?.[time]?.value ||
            (itemInfo.value === 'follower_number' ? null : 0),
        );
      });

      // 对followers数据进行兼容
      if (itemInfo.value === 'follower_number') {
        // let key = y.length - 1;
        // let oldKey = y.length - 2;
        // total = y[key] || 0;
        // total_old = y[oldKey] || 0;
        // total_ratio = getRationPercentValue(total || 0, total_old || 0);
        newTime = [newTime[1]];
        oldTime = [oldTime[1]];
      }

      localStatistics = { x, y };
      localTotalInfo = {
        total,
        total_old,
        total_ratio:
          itemInfo.value === 'follower_number' &&
          (total === 0 || total_old === 0)
            ? 0
            : total_ratio,
        oldTime,
        newTime,
      };
      localNoData = false;
    }

    return [localStatistics, localTotalInfo, localNoData];
  }, [itemInfo]);
  const { formatMessage } = useIntl();
  return (
    <div className="dbo-accounts-metric">
      <div className="dbo-accounts-metric-hd">
        {channel?.img && (
          <img className="dbo-accounts-metric-icon" src={channel.img} />
        )}
        <BubbleCommon placement="top" showIcon={false} tipsMap={itemInfo.tips}>
          <span className="dbo-accounts-metriccard-tit">
            {formatMessage({ id: itemInfo.text })}
          </span>
        </BubbleCommon>
      </div>
      <div className="dbo-accounts-metric-bd">
        <span className="dbo-accounts-metric-databox">
          {reviewsFormat(totalInfo?.total)}
        </span>

        <PercentageItem percentage={totalInfo.total_ratio}>
          {(element) => (
            <RingRatioBubble
              oldTime={totalInfo?.oldTime}
              newTime={totalInfo?.newTime}
              oldValue={totalInfo?.total_old}
              newValue={totalInfo?.total}
              showContent={!noData}
              formateDate={(key) =>
                !key ? '-' : moment(key).format('YYYY-MM-DD')
              }
              formateValue={(key) => `${reviewsFormat(key, 2)}`}
              title={initialUpperCase(itemInfo.params)}
            >
              {element}
            </RingRatioBubble>
          )}
        </PercentageItem>
      </div>
      {!noData && (
        <Chart
          dateType={keepParams.date_type}
          text={itemInfo.text}
          statistics={statistics}
        ></Chart>
      )}
    </div>
  );
}
